/* JDC — Selector de ciudad de envío (lista DANE) para el carrito (página + drawer).
   Guarda la ciudad como atributo de la orden "Ciudad de envío" = "Ciudad|Departamento|DANE".
   Bloquea el checkout hasta que se elija ciudad. Se re-inicializa tras los re-render AJAX del tema T4S. */
(function () {
  if (window.__jdcCityInit) return; window.__jdcCityInit = true;
  var ATTR = 'Ciudad de envío';
  var state = { city: null };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function norm(s){
    return (s||'').toLowerCase()
      .replace(/[áàä]/g,'a').replace(/[éèë]/g,'e').replace(/[íìï]/g,'i')
      .replace(/[óòö]/g,'o').replace(/[úùü]/g,'u').replace(/ñ/g,'n');
  }
  function cities(){ return window.JDC_CIUDADES || []; }

  function search(t){
    t = norm(t).trim(); if(!t) return [];
    var C = cities(), a = [], b = [];
    for (var i=0;i<C.length;i++){
      var c = C[i], n = norm(c.c);
      if (n.indexOf(t) === 0) a.push(c);
      else if (n.indexOf(t) > -1 || norm(c.d).indexOf(t) > -1) b.push(c);
      if (a.length + b.length > 80) break;
    }
    return a.concat(b).slice(0,60);
  }

  function fetchCart(cb){
    fetch(root + 'cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(c){ state.city = (c.attributes && c.attributes[ATTR]) || null; cb && cb(); })
      .catch(function(){ cb && cb(); });
  }

  function saveCity(canonical){
    var body = { attributes: {} }; body.attributes[ATTR] = canonical;
    return fetch(root + 'cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(body)
    }).then(function(r){ return r.json(); })
      .then(function(){ state.city = canonical; applyGate(); })
      .catch(function(){});
  }

  function initContainer(el){
    if (el.__jdcInit) return; el.__jdcInit = true;
    var input = el.querySelector('[data-jdc-city-input]');
    var res   = el.querySelector('[data-jdc-city-res]');
    var ok    = el.querySelector('[data-jdc-city-ok]');
    var hint  = el.querySelector('[data-jdc-city-hint]');
    if (!input || !res) return;
    var cur = [], active = -1;

    function render(){
      res.innerHTML = '';
      if (!cur.length){ res.classList.remove('is-open'); return; }
      cur.forEach(function(c,i){
        var d = document.createElement('div');
        d.className = 'jdc-city__item' + (i===active ? ' is-active' : '');
        d.innerHTML = '<span>'+c.c+' <span class="jdc-city__dep">· '+c.d+'</span></span><span class="jdc-city__dane">'+c.dane+'</span>';
        d.addEventListener('mousedown', function(e){ e.preventDefault(); choose(c); });
        res.appendChild(d);
      });
      res.classList.add('is-open');
    }
    function choose(c){
      input.value = c.c + ', ' + c.d;
      res.classList.remove('is-open'); active = -1;
      el.classList.add('is-selected');
      if (ok){ ok.textContent = '✓ Ciudad registrada: ' + c.c + ', ' + c.d; ok.classList.add('is-show'); }
      if (hint) hint.classList.remove('is-show');
      saveCity(c.c + '|' + c.d + '|' + c.dane);
    }
    input.addEventListener('input', function(){ active = -1; cur = search(input.value); render(); });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); if (res.classList.contains('is-open') && cur[active]) choose(cur[active]); return; }
      if (!res.classList.contains('is-open')) return;
      if (e.key === 'ArrowDown'){ active = Math.min(active+1, cur.length-1); render(); e.preventDefault(); }
      else if (e.key === 'ArrowUp'){ active = Math.max(active-1, 0); render(); e.preventDefault(); }
      else if (e.key === 'Escape'){ res.classList.remove('is-open'); }
    });
    input.addEventListener('blur', function(){ setTimeout(function(){ res.classList.remove('is-open'); }, 160); });

    var dc = el.getAttribute('data-current');
    if (dc && dc.indexOf('|') > -1){
      var p = dc.split('|');
      input.value = p[0] + ', ' + p[1];
      el.classList.add('is-selected');
      if (ok){ ok.textContent = '✓ Ciudad registrada: ' + p[0] + ', ' + p[1]; ok.classList.add('is-show'); }
    }
  }

  function applyGate(){
    var has = !!state.city;
    document.querySelectorAll('.t4s-btn__checkout').forEach(function(b){
      b.classList.toggle('jdc-disabled', !has);
      b.setAttribute('aria-disabled', has ? 'false' : 'true');
    });
    document.querySelectorAll('[data-shopify="dynamic-checkout"], .t4s-additional-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button').forEach(function(b){
      b.style.display = has ? '' : 'none';
    });
    document.querySelectorAll('[data-jdc-city]').forEach(function(el){
      var hint = el.querySelector('[data-jdc-city-hint]');
      if (hint) hint.classList.toggle('is-show', !has && !el.classList.contains('is-selected'));
    });
  }

  // Bloqueo duro: si no hay ciudad, intercepta el click en checkout
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.t4s-btn__checkout');
    if (!btn) return;
    if (!state.city){
      e.preventDefault(); e.stopPropagation();
      var el = document.querySelector('[data-jdc-city]');
      if (el){
        el.scrollIntoView({ behavior:'smooth', block:'center' });
        var h = el.querySelector('[data-jdc-city-hint]'); if (h) h.classList.add('is-show');
        var inp = el.querySelector('[data-jdc-city-input]'); if (inp) inp.focus();
      }
    }
  }, true);

  function boot(){ document.querySelectorAll('[data-jdc-city]').forEach(initContainer); applyGate(); }
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    fetchCart(boot);
    var obs = new MutationObserver(function(){ document.querySelectorAll('[data-jdc-city]').forEach(initContainer); applyGate(); });
    obs.observe(document.body, { childList:true, subtree:true });
    document.addEventListener('t4s:opened', function(){ setTimeout(boot, 60); });
  });
})();
